export enum CartIoEntity {
    Carts = 'carts',
    CartItems = 'cart_items',
}